import React, { useMemo, useRef } from 'react';
import { useStore } from '@/store';
import { useState } from 'react';
import { useEffect } from 'react';
import { DataRow } from '@/types';
// import { Range } from 'react-range';

const Hint: React.FC = () => {
  const refDiv = useRef<HTMLDivElement>();

  const getArt = useStore((state) => state.getArt);
  const [artNow, setArtNow] = useState<DataRow>();

  const artId = useStore((state) => state.artId);
  useEffect(() => {
    const _artNow = getArt(artId);
    const div = refDiv.current;

    if (div) {
      div.classList.remove('appear');
      setTimeout(() => {
        setArtNow(_artNow);
        div.classList.add('appear');
      }, 500);
    }
  }, [artId]);

  const artName = artNow?.name ?? '';
  const artAlias = artNow?.alias ?? '';
  const artSize = `${artNow?.sizeX}cm x ${artNow?.sizeY}cm`;
  const artUrl = useMemo(() => {
    const query = encodeURI(`q=${artName} site:nuri.hangeul.go.kr`);
    return `https://google.com/search?${query}`;
  }, [artName]);

  const artSerial = artNow?.serial ?? '';
  const artYear = useMemo(() => {
    if (!artNow?.year && !artNow?.century) return '시기 불명';
    if (artNow?.year === 0) return `${artNow?.century}세기`;
    return `${artNow?.year}년`;
  }, [artId]);
  return (
    <div
      className="hint appearable appear"
      ref={refDiv as React.LegacyRef<HTMLDivElement> | undefined}
    >
      <p>{artSerial}</p>
      <a
        href={artUrl}
        className="check-detail art-name"
        target="_blank"
        rel="noreferrer"
      >
        <img src="/link-out.svg" alt="link out icon" />
        {artName}
      </a>
      {artAlias !== '' && <p>{artAlias}</p>}
      <p>{artSize}</p>
      <p>{artYear}</p>

      {/* <div className="range-slider">
        <Range
          step={1}
          min={0}
          max={10}
          values={[1]}
          onChange={(v) => v}
          renderTrack={({ props, children }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: '3px',
                width: '100%',
                backgroundColor: '#ccc',
              }}
            >
              {children}
            </div>
          )}
          renderThumb={({ props }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: '9px',
                width: '5px',
                backgroundColor: '#999',
              }}
            />
          )}
        />
      </div> */}
    </div>
  );
};

export default Hint;
